import isURL from 'validator/lib/isURL';

export const meetingType = [
  {
    name: 'oneOnOne',
    title: '1-On-1 Appointment',
    description: 'A private appointment that happens once.',
    isGroupMeeting: false,
  },
  {
    name: 'group',
    title: 'Group Appointment',
    description: 'For 3+ participants and happens once.',
    isGroupMeeting: true,
  },

  /*this meeting types will add to version higher than 1.0v*/
  // {
  //   id: 'oneByOneRegularly',
  //   name: 'Recurring 1-On-1 Meetings',
  //   description: 'A private meeting that happens regularly (every week, every month etc.)',
  //   type: OneOnOneType,
  //   isOnceMeeting: false,
  // },
  // {
  //   id: 'groupOnceRegularly',
  //   name: 'Recurring Group Meetings',
  //   description: 'For 3+ participants and happens regularly (every week, every month etc.)',
  //   type: groupType,
  //   isOnceMeeting: false,
  // }
];

export const createNewTitle = (sessionTime, title, onEdit = false) => {
  const replaceWordsForTitle = onEdit ? title.split(' ').slice(2).join(' ') : 'Appointment';

  return `${sessionTime} ${
    sessionTime === 1 ? 'Hour' : sessionTime < 10 ? 'Hours' : 'Minutes'
  } ${replaceWordsForTitle}`;
};

const defaultTitleElements = ['minutes', 'hour', 'hours'];

export const isDefaultTitle = (title) => {
  const titleToCheck = title.split(' ');
  const firstWord = parseInt(titleToCheck[0]);
  const secondWord = titleToCheck[1] ? titleToCheck[1].toLowerCase() : '';
  if (Number.isNaN(firstWord) || !secondWord) {
    return false;
  }
  if (
    (firstWord === 1 && secondWord === 'hour') ||
    (firstWord < 10 && secondWord === 'hours') ||
    (firstWord >= 10 && secondWord === 'minutes')
  ) {
    return defaultTitleElements.includes(secondWord);
  }
  return false;
};

export const isMeetingDurationInTitle = (title) => {
  const titleToCheck = title.split(' ');
  return timeArr.includes(Number(titleToCheck[0]));
};

export const getMeetingDurationFromTitle = (title) => {
  const titleToCheck = title.split(' ');
  return Number(titleToCheck[0]);
};

export const getAddressFromQueryString = (urlString) => {
  if (isURL(urlString)) {
    const url = new URL(urlString);
    const addressParams = new URLSearchParams(url.search);
    return addressParams.get('q');
  }
  return;
};

export const landingOptionId = 'LandingPage';
export const bookingOptionId = 'BookingPage';

export const meetingOptions = [
  {
    id: landingOptionId,
    name: 'A Landing Page',
    description: 'Create a landing page for your appointment and offer your customers to book a time with you.',
  },
  {
    id: bookingOptionId,
    name: 'Booking Only',
    description: 'Let your customers book an appointment from your website or through a custom link.',
  },
];

export const zoomId = 'zoom';
export const googleMeetId = 'google-meet';
export const inPersonMeetingId = 'in-person';
export const customSolutionId = 'custom';

export const noLinkAvailable = 'no-link-available';
export const noLinkUrl = 'https://app.weshare.net'; //default link to prevent location URL error

/* { name: 'Zoom', id: zoomId, isHideOnAddLocationPage: false }, */

export const meetingLocation = [
  { name: 'Google Meet', id: googleMeetId, isHideOnAddLocationPage: false },
  { name: 'In-person Meeting', id: inPersonMeetingId, isHideOnAddLocationPage: false },
  { name: 'Custom Solution', id: customSolutionId, isHideOnAddLocationPage: false },
  { name: 'No link available', id: noLinkAvailable, isHideOnAddLocationPage: true },
];

export const shareOptions = [
  { name: 'Link', id: '1' },
  { name: 'Booking Widget', id: '2' },
  { name: 'ChatBot', id: '3' },
  { name: 'QR Code', id: '4' },
  { name: 'Custom Form', id: '5' },
  { name: 'Email Scheduling', id: '6' },
];
export const shareOptionsEditing = [
  { name: 'Link', id: '1' },
  { name: 'Booking Widget', id: '2' },
  { name: 'ChatBot', id: '3' },
  { name: 'QR Code', id: '4' },
  { name: 'Custom Form', id: '5' },
];
export const customerProperties = [{name: 'Organization', value: 'organization'}, {name: 'Job Title', value: 'demographics.jobTitle'},{name: 'Team Size', value: 'demographics.teamSize'}, {name: 'Mobile Number', value: 'mobileNumber'}, {name: 'Phone Number', value: 'phoneNumber'}, {name: 'Address', value: 'address'}, {name: 'Website', value: 'website'}, {name: 'Fax', value: 'fax'}, {name: 'Other', value: 'other'}, {name: 'LinkedIn Url', value: 'socialMedia.linkedInUrl'}, {name: 'X Url', value: 'socialMedia.xUrl'}, {name: 'Facebook Url', value: 'socialMedia.facebookUrl'}, {name: 'Instagram Url', value: 'socialMedia.instagramUrl'}, {name: 'Pinterest Url', value: 'socialMedia.pinterestUrl'}, {name: 'YouTube Url', value: 'socialMedia.youtubeUrl'}, {name: 'TikTok Url', value: 'socialMedia.tiktokUrl'}, {name: 'Street Address 1', value: 'address.streetAddress1'}, {name: 'Street Address 2', value: 'address.streetAddress2'}, {name: 'City', value: 'address.city'}, {name: 'State', value: 'address.state'}, {name: 'Zip Code', value: 'address.postalCode'}, {name: 'Country', value: 'address.country'}, {name: 'Age', value: 'demographics.age'}, {name: 'Gender', value: 'demographics.gender'}, {name:'Martial Status', value: 'demographics.martialStatus'}, {name: 'Ethnicity', value: 'demographics.ethnicity'}, {name: 'Income', value: 'demographics.income'}, {name: 'Education', value: 'demographics.education'}];
export const formFieldOptions = ['text', 'number', 'dropdown', 'radio', 'textarea'];
export const validStates = ['al', 'alabama', 'ak', 'alaska', 'az', 'arizona', 'ar', 'arkansas', 'ca', 'california', 'co', 'colorado', 'ct', 'connecticut', 'de', 'delaware', 'fl', 'florida', 'ga', 'georgia', 'hi', 'hawaii', 'id', 'idaho', 'il', 'illinois', 'in', 'indiana', 'ia', 'iowa', 'ks', 'kansas', 'ky', 'kentucky', 'la', 'louisiana', 'me', 'maine', 'md', 'maryland', 'ma', 'massachusetts', 'mi', 'michigan', 'mn', 'minnesota', 'ms', 'mississippi', 'mo', 'missouri', 'mt', 'montana', 'ne', 'nebraska', 'nv', 'nevada', 'nh', 'new hampshire', 'nj', 'new jersey', 'nm', 'new mexico', 'ny', 'new york', 'nc', 'north carolina', 'nd', 'north dakota', 'oh', 'ohio', 'ok', 'oklahoma', 'or', 'oregon', 'pa', 'pennsylvania', 'ri', 'rhode island', 'sc', 'south carolina', 'sd', 'south dakota', 'tn', 'tennessee', 'tx', 'texas', 'ut', 'utah', 'vt', 'vermont', 'va', 'virginia', 'wa', 'washington', 'wv', 'west virginia', 'wi', 'wisconsin', 'wy', 'wyoming'];
export const validCountries = ["afghanistan", "albania", "algeria", "andorra", "angola", "antigua and barbuda", "argentina", "armenia", "australia", "austria", "azerbaijan", "bahamas", "bahrain", "bangladesh", "barbados", "belarus", "belgium", "belize", "benin", "bhutan", "bolivia", "bosnia and herzegovina", "botswana", "brazil", "brunei", "bulgaria", "burkina faso", "burundi", "cabo verde", "cambodia", "cameroon", "canada", "central african republic", "chad", "chile", "china", "colombia", "comoros", "congo", "costa rica", "cote d'ivoire", "croatia", "cuba", "cyprus", "czech republic", "denmark", "djibouti", "dominica", "dominican republic", "east timor", "ecuador", "egypt", "el salvador", "equatorial guinea", "eritrea", "estonia", "eswatini", "ethiopia", "fiji", "finland", "france", "gabon", "gambia", "georgia", "germany", "ghana", "greece", "grenada", "guatemala", "guinea", "guinea-bissau", "guyana", "haiti", "honduras", "hungary", "iceland", "india", "indonesia", "iran", "iraq", "ireland", "israel", "italy", "jamaica", "japan", "jordan", "kazakhstan", "kenya", "kiribati", "north korea", "korea, south", "kosovo", "kuwait", "kyrgyzstan", "laos", "latvia", "lebanon", "lesotho", "liberia", "libya", "liechtenstein", "lithuania", "luxembourg", "madagascar", "malawi", "malaysia", "maldives", "mali", "malta", "marshall islands", "mauritania", "mauritius", "mexico", "micronesia", "moldova", "monaco", "mongolia", "montenegro", "morocco", "mozambique", "myanmar", "namibia", "nauru", "nepal", "netherlands", "new zealand", "nicaragua", "niger", "nigeria", "north macedonia", "norway", "oman", "pakistan", "palau", "palestine", "panama", "papua new guinea", "paraguay", "peru", "philippines", "poland", "portugal", "qatar", "romania", "russia", "rwanda", "saint kitts and nevis", "saint lucia", "saint vincent and the grenadines", "samoa", "san marino", "saudi arabia", "senegal", "serbia", "seychelles", "sierra leone", "singapore", "slovakia", "slovenia", "solomon islands", "somalia", "south africa", "south sudan", "spain", "sri lanka", "sudan", "suriname", "sweden", "switzerland", "syria", "taiwan", "tajikistan", "tanzania", "thailand", "togo", "tonga", "trinidad and tobago", "tunisia", "turkey", "turkmenistan", "tuvalu", "uganda", "ukraine", "united arab emirates", "united kingdom", "united states", "uruguay", "uzbekistan", "vanuatu", "vatican city", "venezuela", "vietnam", "yemen", "zambia", "zimbabwe"];

export const timeArr = [
  10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 1, 75, 1.5, 105, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9,
  9.5,
];
export const breakTimeArr = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];

export const amountArr = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
];
export const amountRevArr = [
  30, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
];

export const defaultDuration = {
  sessionTime: 45,
  breakTime: 15,
};

export const participantsArr = new Array(99).fill('').map((_, index) => index + 2);

export const priceArr = new Array(202).fill('').map((_, index) => {
  if (index === 0) return 1;
  if (index === 1) return 3;
  return (index - 1) * 5;
});

export const initialBenefits = [{ name: '24/7 Availability', isBasicChecked: false, isSubscriptionChecked: false }];

export const initialThankYouPageValue = {
  title: 'Thank You!',
  text: `<p>Your appointment booking was successful.</p>
  <p>We're looking forward to meeting you.</p>
  <p>Appointment Details:</p>
  <ul>
  <li>Title: {meetingTitle}</li>
  <li>Date: {meetingDate}</li>
  <li>Time: {meetingTime}</li>
  <li>With: {hostName}</li>
  <li>Location: {meetingLocation}</li>
  </ul>
  <p>The best way to get reminders to your appointment is by adding it to your calendar:</p>
  <p>{calendarButtons}</p>`,
};

export const initialBasicPackage = {
  idName: 'basic',
  name: 'Book an appointment👇',
  description: '',
  sessionTime: defaultDuration.sessionTime,
  breakTime: defaultDuration.breakTime,
  meetingsPerDay: 30,
  price: 0,
  buttonText: 'Book Today',
};

export const initialSubscriptionPackage = {
  idName: 'subscription',
  name: 'Subscription',
  description: '',
  price: 15,
};
